export default __webpack_public_path__ + "static/media/shoppinglist_female@3x.1af11e0b.png";